import { useMe, useNote } from 'shared/hooks';
import { useAppointmentFromContext } from 'pages/Appointment';
export var useSharedNoteEventData = function (noteID) {
    var _a, _b, _c, _d;
    var userDetails = useMe();
    var appointment = useAppointmentFromContext();
    var getNote = useNote(noteID);
    return {
        location: window.location.href,
        appointment_id: appointment === null || appointment === void 0 ? void 0 : appointment.id,
        scheduled_appointment_type: appointment === null || appointment === void 0 ? void 0 : appointment.kind,
        note_status: ((_a = getNote.data) === null || _a === void 0 ? void 0 : _a.signedAt) ? "signed" /* NoteStatus.signed */ : "draft" /* NoteStatus.draft */,
        note_type: (_b = getNote.data) === null || _b === void 0 ? void 0 : _b.sessionInfo.noteType,
        note_id: (_c = getNote.data) === null || _c === void 0 ? void 0 : _c.id,
        role: (_d = userDetails.data) === null || _d === void 0 ? void 0 : _d.roles,
    };
};
